import { get, post, put, destroy } from './config';

const User = {
    get: () =>
        get('/v1/users'),
    registerNew: (data) =>
        post('/v1/users/client/register', data),
    update: (data) =>
        post('/v1/users/update', data),
    getCoordinate: (number) =>
        get(`v1/orders/positions/list?orderNo=${number} `),
    getHistory: (id) => 
        get(`v1/orders/states/${id} `),
    changePassword: (data) =>
        post('/v1/users/change-password', data),
    getDriverById: (driverId) =>
        get(`v1/users/by-${driverId}`),
    getCheck: (type, value) =>
        get(`v1/users/client/check/${type}/${value}`),
    isActive: () =>
        get(`v1/users/drivers/isactive`),
    forgotPassword: (email) => 
        post('/v1/users/forgot-password', {email} ),
    checkСodePassword: (code) => 
        post('/v1/users/reset-password/check-code', {code} ),
    resetPassword: (data) =>
        post('/v1/users/reset-password', data),
    sendConfirmationEmail: (email) =>
        post('/v1/users/client/email-send-confirmation', { email }),
    checkСodeEmail: (code, email) =>
        post('/v1/users/client/email-confirmation', { code, email }),
    updateStep: (step) =>
        post('/v1/users/client/update-step', { step }),
    updateEmail: (email) =>
        post('/v1/users/client/update-email', { email }),
    updateRole: (userId, roleId) =>
        put(`v1/users/client/update-role/${userId}/${roleId}`),
    checkEmail: (email) =>
        post('/v1/users/client/check/email', { email }),
    checkPhone: (phoneNumber) =>
        post('/v1/users/client/check/phone', { phoneNumber }),
    checkBin: (bin) =>
        post('/v1/users/client/check/bin', { bin }),
    addPartner: (data) =>
        post('/v1/expeditor', data),
    getPartners: () =>
        get('/v1/expeditor'),
    getCodeInfo: (code) =>
        get(`/v1/expeditor/${code}`),
    registerInvitationExpeditor: (clientId, code, data) =>
        post(`/v1/users/client/invitation-expeditor/register/${clientId}/${code}`, data),
    confirmPartner: (userId, body) =>
        post(`/v1/users/confirm/expeditor/${userId}`, body),
    rejectPartner: (userId, body) =>
        post(`/v1/users/reject/expeditor/${userId}`, body),
}

export default User;
